export const directAccessConfigs = {
    vulcan: {
      directUrls: [
        '/en-US/directAccessToPureFibre',
        '/fr-CA/directAccessToPureFibre'
      ],
      webformUrls: {
        'en-US': '/en-US/vulcan/Vulcan_Landing_Page',
        'fr-CA': '/fr-CA/vulcan/Vulcan_Landing_Page'
      }
    },
    wireline: {
      directUrls: [
        '/en-US/directAccessToWireline',
        '/fr-CA/directAccessToWireline'
      ],
      webformUrls: {
        'en-US': '/en-US/wireline_and_secure_business/Landing_Page',
        'fr-CA': '/fr-CA/wireline_and_secure_business/Landing_Page'
      }
    }
  };